export default (store) => (next) => (action) => {
  if (action && typeof action.then !== 'function') {
    return next(action);
  }

  return Promise.resolve(action).then(store.dispatch);
};
